export enum PAYMENT_TYPES {
    KLARNA = 'Klarna',
    PAYPAL = 'PayPal',
    APPLE = 'ApplePay',
}
